<template>
    <div>
        <div v-if="$wait.is('fetching')" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
        <div
            v-else-if="items && items.length"
            class="sector-post-feed"
        >
            <SectorPostCard
                v-for="item in items"
                :key="`sector-post-${item.id}`"
                :resource="item"
                :load-comments="false"
                :sector-id="sectorIds[0]"
                @model-updated="handlePostUpdated"
                @comment-click="handleNavigationToPost(item.id)"
                @deleted="handlePostDeleted"
            />
            <mugen-scroll
                v-if="items.length && !end"
                scroll-container="main-content"
                :handler="loadMore"
                :should-handle="!$wait.is('fetching_more')"
                :threshold="0.75"
            >
                <div class="loading">
                    <Spinner :height="30" :width="30"/>
                </div>
            </mugen-scroll>
        </div>
        <div v-else-if="end && !items.length" class="no-results">
            <span>There are currently no posts — be the first to share your thoughts!</span>
        </div>
    </div>
</template>
<script>
import MugenScroll from 'vue-mugen-scroll';
import API from '@api';
import Spinner from '@components/Spinner';
import LayoutWithContainer from '@layouts/LayoutWithContainer';
import SectorPostCard from '@components/Sector/Post/Card';

const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

export default {
    name: 'SectorPostFeed',
    components: {
        SectorPostCard,
        LayoutWithContainer,
        Spinner,
        MugenScroll
    },
    data: () => ({
        items: [],
        page: 1,
        end: false,
        busy: true
    }),
    props: {
        sectorIds: {
            type: Array,
            required: true,
        },
    },
    methods: {
        async fetchResource() {
            try {
                const { data, meta } = await API.getSectorFeed({
                    sectors: this.sectorIds,
                    page: this.page,
                });

                this.end = meta.last_page === this.page;
                this.page = this.page + 1;

                return data;
            } catch(err) {
                throw new Error(err.message);
            }
        },
        async loadInitial(visible = false, insertTemp = null){
            console.log({ insertTemp, test: visible ? 'fetching': 'updating' });

            if(this.$wait.is('fetching') || this.$wait.is('updating'))
                return false;

            this.page = 1;

            this.$wait.start(visible ? 'fetching': 'updating');

            if(insertTemp) {
                this.items = [ ...[insertTemp], ...this.items ];
                await sleep(2000);
            }

            try {
                const items = await this.fetchResource();

                if(!items.length){
                    this.end = true;
                    this.items = [];
                    return false;
                } else {
                    this.items = items;
                    setTimeout(() => { this.busy = false }, 20);
                }
            } catch(e) {
                this.items = [];
            } finally {
                this.$wait.end('fetching');
                this.$wait.end('updating');
            }
        },
        async loadMore() {
            this.$wait.start('fetching_more');

            try {
                const items = await this.fetchResource();

                if(!items.length){
                    this.end = true;
                    return false;
                }

                this.items = [ ...this.items, ...items ];
            } catch(e) {
                this.end = true;
            } finally {
                this.$wait.end('fetching_more');
            }
        },
        handlePostUpdated(newPost) {
            const index = (this.items ?? []).findIndex((item) => item.id === newPost.id);
            this.items[index] = newPost;
        },
        handlePostDeleted(removedPostId){
            this.items = this.items.filter((item) => item.id !== removedPostId);
        },
        handleNavigationToPost(postId) {
            this.$router.push({
                name: 'sector-post-view',
                params: {
                    sector_id: this.sectorIds[0],
                    post_id: postId,
                },
            })
        },
    },
    watch: {
        // call again the method if the route changes
        '$route': function() {
            console.log("watch$route");
            this.end = false;
            this.page = 1;
            this.loadInitial(true);
        },
        sectorIds: function() {
            console.log("watchSectorIds");
            this.end = false;
            this.page = 1;
            this.loadInitial(true);
        },
    },
    created() {
        console.log("created");
        this.end = false;
        this.page = 1;
        this.loadInitial(true);
    }
}
</script>
<style lang="scss">
.sector-post-feed {
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    row-gap: 2rem;

    .loading {
        min-height: 10rem;
    }
}
</style>
